import React from 'react'
import css from './support.module.css'

const Support = () => {
  return (
    <div>
    <h3>adasdadasd adasda asfasd</h3>
    <h3>adasdadasd adasda asfasd</h3>
    <h3>adasdadasd adasda asfasd</h3>
    <h3>adasdadasd adasda asfasd</h3>
    <h3>adasdadasd adasda asfasd</h3>
    <h3>adasdadasd adasda asfasd</h3>
    <h3>adasdadasd adasda asfasd</h3>
    <h3>adasdadasd adasda asfasd</h3>
    <h3>adasdadasd adasda asfasd</h3>
    <h3>adasdadasd adasda asfasd</h3>
    </div>
  )
}

export default Support